import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgStarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.711,
    height: 16,
    viewBox: "0 0 16.711 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.846 16a1.089 1.089 0 01-.507-.125l-3.983-2.094-3.983 2.094a1.09 1.09 0 01-1.581-1.149l.761-4.436L.33 7.149a1.09 1.09 0 01.6-1.859l4.453-.647L7.378.608a1.09 1.09 0 011.955 0l1.992 4.036 4.454.647a1.09 1.09 0 01.6 1.859l-3.223 3.141.761 4.436A1.09 1.09 0 0112.846 16z",
    fill: "#0a2239",
    opacity: 0.14
  })));
}

export { SvgStarEmpty as ReactComponent };
//# sourceMappingURL=starEmpty.svg.js.map
